@if (props.tooltip) {
  <i
    class="far fa-lg fa-question-circle pointer d-md-none"
    (click)="openTooltip()"
  ></i>
}

<div class="row justify-content-end">
  @for (button of props.buttons; track $index) {
    <div [ngClass]="'col-' + (12 / numColumns)">
      <div [ngbTooltip]="handleButtonTooltip(button)">
        <button
          class="btn w-100"
          [disabled]="props.disabled"
          [ngClass]="button.className ?? ''"
          [class.disabled]="handleButtonDisabled(button)"
          [type]="button.type ?? 'button'"
          [attr.data-testid]="button.testId"
          (click)="handleButtonClick(button)"
        >
          @if (button.iconClass) {
            <i [ngClass]="button.iconClass"></i>
          }
          {{ button.label }}
        </button>
      </div>
    </div>
  }
</div>
